export default "__VITE_ASSET__afc06696__"